import { ITheme } from '@chakra-ui/core'

import colors from './colors'
import breakpoints from './breakpoints'
import fonts from './fonts'
import fontSizes from './fontSizes'
import fontWeights from './fontWeights'
import zIndices from './zIndices'
import shadows from './shadows'
import lineHeights from './lineHeights'
import radii from './radii'
import opacity from './opacity'
import borders from './borders'
import sizes, { baseSizes as space } from './sizes'
import icons from './icons'
import letterSpacings from './letterSpacings'
// import iconSizes from './iconSizes'

export interface Theme extends ITheme {
  fonts: ITheme['fonts'] & {
    heading2?: string
  }
}

export const theme: ITheme = {
  colors,
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  zIndices,
  shadows,
  lineHeights,
  radii,
  opacity,
  borders,
  sizes,
  space,
  icons,
  letterSpacings,
  // iconSizes,
}

export default theme
